var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e05783fa719ba36c7abaa0ce05c8c17f7e7244b9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["zonadonext@zonado-d4"]={id:"e05783fa719ba36c7abaa0ce05c8c17f7e7244b9"};
      